<template>
  <div class="system-builder__main-remotes--item" @click="toggleSelected" :class="{ 'selected-remote': active}">
    <div class="system-builder__main-remotes--item-image">
      <slot name="remote-image"></slot>
    </div>

    <div class="system-builder__main-remotes--item-content">
      <slot name="remote-description"></slot>
    </div>
    <button class="button__solid--blue">Select</button>
  </div>
</template>

<script>
  import store from '../../store/index'
  import router from '../../router/index'

  export default {
    name: 'remoteItem',
    data () {
      return {
        sharedState: store.state,
        active: false,
        remoteId: this.id
      }
    },
    props: ['id', 'remoteKey'],
    methods: {
      toggleSelected: function () {
        var selectedRemoteId = this.id
        var currentSelectedId = this.sharedState.selectedRemoteId
        // var remoteObj = {}

        if (selectedRemoteId === currentSelectedId) {
          store.updateSelectedRemoteId(0)
          // store.updateSelectedRemoteObj(remoteObj)
        } else {
          store.updateSelectedRemoteId(selectedRemoteId)
          // remoteObj = this.sharedState.remotes[parseInt(this.remoteKey)]
          // store.updateSelectedRemoteObj(remoteObj)
          store.setLocalStorageRemote()
        }

        if (this.id === this.sharedState.selectedRemoteId) {
          this.active = true
          store.updateCurrentStepValidation(true)

          // Navigate to view system, if not view select remote step
          if (this.sharedState.currentStep.id === 'selectRemote') {
            store.updateCurrentStateRoute('selectUpgrades')
            router.push({name: 'selectUpgrades'})
          }
        } else {
          this.active = false
          store.updateCurrentStepValidation(false)
        }
      }
    },
    mounted: function () {
      if (this.id === this.sharedState.selectedRemoteId) {
        this.active = true
      } else {
        this.active = false
      }
    },
    beforeUpdate: function () {
      if (this.id === this.sharedState.selectedRemoteId) {
        this.active = true
      } else {
        this.active = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RemoteItem.vue?5b67173b